/**
 * @voltxampere/components — JFET dedicated component (Sprint 23 B3)
 *
 * Junction Field-Effect Transistor — Sprint 22'ye kadar UI symbol
 * library'de sembol vardı ama engine stamp YOKTU. Sprint 23 B3
 * SPICE Level 1 (Shichman-Hodges JFET) formülasyonu ile DC + AC
 * stamp'ı ship eder.
 *
 * Önemli farklar (MOSFET'e karşı):
 * - JFET depletion-mode: N-channel için varsayılan Vt0 = -2 V (cutoff
 *   Vgs ≤ Vt0). Pozitif Vgs daha çok akım açar.
 * - β doğrudan parametre (MOSFET'in `Kp · W/L`'sı yerine).
 * - Body terminali yok (D, G, S).
 * - Gate-channel junction'ı forward bias edilirse diode gibi
 *   davranır — Sprint 23'te basitleştirilmiş; gate akımı ihmal edilir
 *   (Vgs ≥ 0.5 V durumlarında modelimiz hatalı, kullanıcı uyarıyı
 *   schematic seviyesinde alır).
 *
 * Sprint 22 D4 junction-cap parametreleri (Cgs0, Cgd0) JFET için
 * de geçerli — additive, zero-default.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const JfetParamsSchema = z
    .object({
    /**
     * Transconductance parameter `β` (A/V²). Default 1e-4 — typical
     * 2N3819 N-JFET için makul başlangıç değeri.
     */
    Beta: z.number().positive().finite().default(1e-4),
    /**
     * Threshold voltage `Vt0` (V). N-channel için NEGATİF (depletion-
     * mode default -2V), P-channel için POZİTİF (default +2V).
     * Schema-level varsayılan -2V (n-channel kabulü); polariteye göre
     * UI dropdown override eder.
     */
    Vt0: z.number().finite().default(-2),
    /**
     * Channel-length modulation `λ` (1/V). Default 0.01 — moderate
     * output conductance.
     */
    Lambda: z.number().nonnegative().finite().default(0.01),
    /** Optional gate-source junction cap (Sprint 22 D4 pattern). */
    Cgs0: z.number().nonnegative().finite().optional(),
    /** Optional gate-drain junction cap. */
    Cgd0: z.number().nonnegative().finite().optional(),
})
    .strict();
export const jfetNDefinition = {
    type: "jfet-n",
    category: "active",
    displayName: { tr: "N-Kanal JFET", en: "N-channel JFET" },
    symbol: "Q",
    pins: [
        { id: "drain", side: "right", offset: -10, label: "D" },
        { id: "gate", side: "left", offset: 0, label: "G" },
        { id: "source", side: "right", offset: 10, label: "S" },
    ],
    parameterSchema: JfetParamsSchema,
    nonlinear: true,
};
export const jfetPDefinition = {
    type: "jfet-p",
    category: "active",
    displayName: { tr: "P-Kanal JFET", en: "P-channel JFET" },
    symbol: "Q",
    pins: [
        { id: "drain", side: "right", offset: -10, label: "D" },
        { id: "gate", side: "left", offset: 0, label: "G" },
        { id: "source", side: "right", offset: 10, label: "S" },
    ],
    parameterSchema: JfetParamsSchema,
    nonlinear: true,
};
//# sourceMappingURL=jfet.js.map